import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import alwaysNoop from 'utils/functions/nullary/alwaysNoop.util';
import nullBind from 'utils/functions/nullBind.util';
import logger from 'utils/logger.util';
import isFn from 'utils/predicates/function/isFn.util';
import isNotFn from 'utils/predicates/function/isNotFn.util';

const L = logger('pubsub');

const raiseOne = ({ onBefore, fn, tag }) => {
  try {
    const v = onBefore ? fn(onBefore()) : fn();
    return { v };
  } catch (e) {
    L.warn('raiseOne()', tag, e);
    return { e };
  }
};

const pubsub = (options) => {
  const subscribers = new Set();

  const tag = fromAnyToTrimmed(options?.tag);
  const onBefore = isFn(options?.onBefore) ? options.onBefore : null;

  const raise = () => {
    for (const fn of [...subscribers.values()]) {
      raiseOne({ onBefore, fn, tag });
    }
  };

  const unsubscribe = (fn) => void subscribers.delete(fn);

  const subscribe = (fn) => {
    if (isNotFn(fn)) {
      L.warn('subscribe()', tag, 'Invalid function:', fn);
      return alwaysNoop;
    }

    subscribers.add(fn);
    raiseOne({ onBefore, fn, tag });

    return nullBind(unsubscribe, fn);
  };

  return {
    raise,
    subscribe,
    unsubscribe,
  };
};

export default pubsub;
